import { render, staticRenderFns } from "./LearnStatus.vue?vue&type=template&id=63cbb141&"
import script from "./LearnStatus.vue?vue&type=script&lang=ts&"
export * from "./LearnStatus.vue?vue&type=script&lang=ts&"
import style0 from "./LearnStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports